export const baseMoneyFragment = `
fragment baseMoneyFragment on BaseMoney {
  type
  currencyCode
  centAmount
  fractionDigits
}
`;
